import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route changes, but NOT when only the language segment changes.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = sessionStorage.getItem("prev-path") || "";
    sessionStorage.setItem("prev-path", pathname);

    // Language-only switch detection: only the /ar or /en prefix changed but the rest is equal.
    const stripLang = (p) => p.replace(/^\/(ar|en)(?=\/|$)/, "") || "/";
    if (stripLang(prev) === stripLang(pathname) && prev !== pathname && prev !== "") {
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
